import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import { LoaderOverlay, bind } from 'vdlib';
import { history } from 'data/Store';

import logo from 'static/img/logo.png';

import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';

import vdfmlogo from 'static/img/VDFM_small.png';

import { Typography } from 'antd';

const { Paragraph, Title } = Typography;

const imageStyle = {
  height: '71px',
  width: '200px',
  marginTop: 5,
  textAlign: 'center',
};

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      message: '',
      notActive: false,
    };

    bind(this, ['getRedirectLocation', 'onChange', 'handleSubmit']);
  }

  componentWillMount() {
    if (this.props.user != null)
      return history.replace(this.getRedirectLocation());
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user != null)
      return history.replace(this.getRedirectLocation());

    if (this.props.error != nextProps.error) {
      this.setState({
        message: nextProps.error,
        notActive:
          nextProps.error.response &&
          nextProps.error.response.data &&
          nextProps.error.response.data.Message &&
          nextProps.error.response.data.Message.Description ===
            'User is inactive!',
      });
    }
  }

  getRedirectLocation() {
    let from = (this.props.location.state || {}).from;
    return from
      ? { pathname: from.pathname, query: from.query }
      : { pathname: '/' };
  }

  onChange(input, e) {
    this.setState({
      message: '',
      [input]: this[`_${input}Ref`].value,
      //[`${input}Dirty`]: true
    });
  }

  handleSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    //TODO: need the button to lose focus or LoaderOverlay animation doesn't work !!! ??? ¯\_(ツ)_/¯
    this._usernameRef.focus();
    this.props.onPerformLogin(this.state.username, this.state.password);
    return false;
  }

  handleCancel = e => {
    this.setState({
      notActive: false,
    });
  };

  render() {
    let buttonDisabledClass = this.props.loading ? 'disabled' : '';

    return (
      <div>
        <LoaderOverlay loading={this.props.loading} />
        <form
          className="login-form"
          onSubmit={this.handleSubmit}
          method="post"
          noValidate={true}
        >
          <div className="text-center">
            <a href="javascript:;">
              <img src={logo} alt="logo" style={imageStyle} />
            </a>
          </div>
          {/* <h3 className="form-title font-yellow">
            <Translate value="VDCARS" />
          </h3> */}
          <div className="alert alert-danger display-hide">
            <button className="close" data-close="alert" />
            <span> Enter any username and password. </span>
          </div>
          <div className="form-group">
            <label className="control-label visible-ie8 visible-ie9">
              <Translate value="USERNAME" />
            </label>
            <input
              className="form-control form-control-solid placeholder-no-fix"
              value={this.state.username}
              onChange={e => this.onChange('username', e)}
              ref={elem => (this._usernameRef = elem)}
              type="text"
              autoComplete="off"
              placeholder={I18n.t('USERNAME')}
              name="username"
            />
          </div>
          <div className="form-group">
            <label className="control-label visible-ie8 visible-ie9">
              <Translate value="PASSWORD" />
            </label>
            <input
              className="form-control form-control-solid placeholder-no-fix"
              value={this.state.password}
              onChange={e => this.onChange('password', e)}
              ref={elem => (this._passwordRef = elem)}
              type="password"
              autoComplete="off"
              placeholder={I18n.t('PASSWORD')}
              name="password"
            />
          </div>
          <div className="form-actions">
            <button
              type="submit"
              className={`btn uppercase float-right ${buttonDisabledClass}`}
              disabled={this.props.loading}
              style={{ backgroundColor: '#FABC3C', color: '#FFF' }}
            >
              <Translate value="LOGIN" />
            </button>
            <div className="clear" />
          </div>
          <div style={{ clear: 'both', marginBottom: '20px' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: '#FABC3C' }}>
              <strong>Email:</strong> info@vdfm.gr
            </span>
            <span style={{ color: '#FABC3C' }}>
              <strong>Τηλέφωνο:</strong> 210-9313001
            </span>
          </div>
          {/* <a
            href="javascript:;"
            onClick={() =>
              this.setState({
                username: 'info@carexpert.gr',
                password: '123123',
              })
            }
          >
            info@carexpert.gr
          </a>
          &nbsp;|&nbsp;
          <a
            href="javascript:;"
            onClick={() =>
              this.setState({
                username: 'sales@vdfm.gr',
                password: '123123',
              })
            }
          >
            sales@vdfm.gr
          </a>
          &nbsp;|&nbsp;
          <a
            href="javascript:;"
            onClick={() =>
              this.setState({
                username: 'stpass@mail.gr',
                password: '123123',
              })
            }
          >
            stpass@mail.gr
          </a> */}
          {/*
						<a href="javascript:;" onClick={ () => this.setState({ username: 'merchant@mail.com', password: '123123' }) } >Merchant</a>&nbsp;|&nbsp;
						<a href="javascript:;" onClick={ () => this.setState({ username: 'allianz@mail.com', password: '123123' }) } >Insurance</a>&nbsp;|&nbsp;
						<a href="javascript:;" onClick={ () => this.setState({ username: 'stpass@mail.gr', password: '123123' }) } >Admin</a>&nbsp;|&nbsp;
						<a href="javascript:;" onClick={ () => this.setState({ username: 'expert@mail.com', password: '123123' }) } >Expert</a>
						*/}
        </form>
        {this.state.notActive ? (
          <Modal
            visible={this.state.notActive}
            title={
              <div>
                <img src={vdfmlogo} alt="vdfmlogo" className="logo-default" />
              </div>
            }
            footer={null}
            onCancel={this.handleCancel}
          >
            <div style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
              <Title level={4}>Ο λογαριασμός σας έχει απενεργοποιηθεί.</Title>
              <Paragraph>
                Για περισσότερες λεπτομέρειες μπορείτε να επικοινωνήσετε με την
                εταιρεία μας.
              </Paragraph>
              <Paragraph>
                <strong>Τηλέφωνο:</strong> 210-9313001
              </Paragraph>
              <Paragraph>
                <strong>Email:</strong> info@vdfm.gr
              </Paragraph>
              <Paragraph>
                <strong>Διεύθυνση:</strong> VDFM LTD Αιγαίου 5 Νέα Σμύρνη
              </Paragraph>
            </div>
          </Modal>
        ) : null}
      </div>
    );
  }
}

export default Login;
